import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@ui/components';
import { DownloadIcon, FileTextIcon, SheetIcon } from 'lucide-react';
import { FC } from 'react';

interface ExportButtonProps {
  onExcel?: () => void;
  onPdf?: () => void;
}

export const ExportButton: FC<ExportButtonProps> = ({ onExcel, onPdf }) => {
  if (!onExcel && !onPdf) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          aria-label="Export"
          className="h-8 w-8 p-0"
          variant="outline"
        >
          <DownloadIcon
            aria-hidden="true"
            className="size-4"
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {!!onExcel && (
          <DropdownMenuItem
            className="cursor-pointer"
            onSelect={onExcel}
          >
            <SheetIcon className="mr-4 size-4" />
            <span>Excel</span>
          </DropdownMenuItem>
        )}
        {!!onPdf && (
          <DropdownMenuItem
            className="cursor-pointer"
            onSelect={onPdf}
          >
            <FileTextIcon className="mr-4 size-4" />
            <span>PDF</span>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
